import * as React from 'react'

function SvgCircleCheck(props, svgRef) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M21.333 33.334l8 8 13.334-16"
        stroke="#2FAFCC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 58.666c14.727 0 26.666-11.939 26.666-26.666C58.666 17.272 46.727 5.333 32 5.333 17.272 5.333 5.333 17.273 5.333 32c0 14.727 11.94 26.666 26.667 26.666z"
        stroke="#2FAFCC"
        strokeWidth={2}
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgCircleCheck)
export default ForwardRef
